import styled from "styled-components";

export const HyperLinkDiv = styled.div`
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  text-decoration: underline;
  color: #007bff;
`;
